export default __webpack_public_path__ + "images/80833557b7d788e4b7be8470136262e3-nationality.webp";